import { Component, Prop } from 'vue-property-decorator'

import { API } from '@src/lib/api_path'
import { HealthGoal } from '@src/data/goal'
import { DetailsAndTargets } from '@src/routes/members/components/status/details-targets'
import { MemberProfile } from '@src/data/member-profile'
import { convertToYYYYMMDD } from '@src/util/date-format'

type HealthGoalResponse = { health_goal: HealthGoal }

@Component
export class ReadonlyDetailsAndTargets extends DetailsAndTargets {

  @Prop({ required: true })
  member: MemberProfile

  constructor () {
    super()
  }

  protected loadCurrentGoal () {
    return this.apiClient.get(API.MEMBERS_API.HEALTH_GOAL_HISTORY.replace('{date}', convertToYYYYMMDD(new Date())).replace('{healthGoalId}', ''))
      .then((response: HealthGoalResponse) => {
        this.goal = response.health_goal.name || this.$t(`PAGE.MEMBERS.GOALS.${response.health_goal.key}`)
      })
      .catch(error => {
        console.log('cannot load health goal history', error)
        this.$store.dispatch('setGoal', null)
      })
  }

  protected loadBodyMeasurements (): any {
    this.height = this.member.metrics['height'] ? this.member.metrics['height'].slice().sort((a, b) => a.effectiveAt > b.effectiveAt ? -1 : a.effectiveAt < b.effectiveAt ? 1 : 0)[0].value : null
    this.weight = this.member.metrics['body_weight'] ? this.member.metrics['body_weight'].slice().sort((a, b) => a.effectiveAt > b.effectiveAt ? -1 : a.effectiveAt < b.effectiveAt ? 1 : 0)[0].value : null
  }
}
